// removed by extract-text-webpack-plugin
module.exports = {"container":"error__container___12d7D","fadein":"error__fadein___1zzdB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/app/error.scss
// module id = 405
// module chunks = 0